import reduxThunk from 'redux-thunk';
import { combineReducers } from 'redux';
import { applyMiddleware, createStore } from 'redux';

import UserReducer from './User/reducer';

const rootReducer = combineReducers({
    user: UserReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export function configureStore() {
    const middlewares = [reduxThunk];
    const middleWareEnhancer = applyMiddleware(...middlewares);

    const store = createStore(rootReducer, middleWareEnhancer);

    return store;
}

export type AppState = ReturnType<typeof rootReducer>;
